import {
  MSK_DELIVERY_MODE_BY_POINTS,
  MSK_DELIVERY_MODE_BY_POINTS_OPTION,
} from "./common-delivery/by-points";
import {
  MSK_DELIVERY_MODE_FACTORY_TO_CLIENT,
  MSK_DELIVERY_MODE_FACTORY_TO_CLIENT_OPTION,
} from "./common-delivery/factory-to-client";

export const MSK_DELIVERY_CALCULATION_OPTIONS = [
  MSK_DELIVERY_MODE_FACTORY_TO_CLIENT_OPTION,
  MSK_DELIVERY_MODE_BY_POINTS_OPTION,
];

const normalizeText = (value) => String(value || "").trim().toLowerCase().replace(/ё/g, "е");

export const normalizeRegionCode = (value) => {
  const normalized = normalizeText(value);

  if (normalized === "москва" || normalized === "московская область" || normalized === "мск") {
    return "МСК";
  }

  return String(value || "").trim().toUpperCase();
};

export const getDefaultMskDeliveryMode = (region) =>
  normalizeRegionCode(region) === "МСК"
    ? MSK_DELIVERY_MODE_FACTORY_TO_CLIENT
    : MSK_DELIVERY_MODE_BY_POINTS;

export {
  MSK_DELIVERY_MODE_BY_POINTS,
  MSK_DELIVERY_MODE_FACTORY_TO_CLIENT,
};
